import { URL_PARSING_BASE } from 'lib/consts/hostnames'
import { isNextUrlValid } from 'lib/helpers/isNextUrlValid/isNextUrlValid'
import { RouterPage } from 'lib/navigation/consts'

const AUTH_ROUTES: string[] = [
  RouterPage.login,
  RouterPage.loginSetup,
  RouterPage.loginVerify,
  RouterPage.forgotPassword,
]

// Compare what the browser will actually load, not the string: `/login-setup?next=x` and
// `/x/../login-setup` both resolve to the auth route this must refuse.
const isAuthRoute = (url: string): boolean => {
  try {
    return AUTH_ROUTES.includes(new URL(url, URL_PARSING_BASE).pathname)
  } catch {
    return false
  }
}

export interface GetPostLoginNextParams {
  /** Where the 401 happened — `window.location.pathname`. */
  pathname: string
  /** The destination already in flight, read from `Router.query.next`. */
  next: string
}

/**
 * The `next` to carry into `/login` after a session expiry.
 *
 * An auth route is never a destination: sending someone back to `/login-setup` replaces the journey
 * they were on and, via `useSkipMfaNudge`, can bounce them straight back to it. So on an auth route
 * this hands back the destination that route was already carrying, and `null` when there isn't a
 * usable one — better no `next` than a `next` that loops.
 */
export const getPostLoginNext = ({ pathname, next }: GetPostLoginNextParams): string | null => {
  if (!isAuthRoute(pathname)) {
    return pathname
  }

  return isNextUrlValid(next) && !isAuthRoute(next) ? next : null
}
